import styles from './project.module.css';
import OneSkill from '../Skills/OneSkill'


const UrbanC=()=>{
    return <div className={styles.projects_container}>
    <div className={styles.project}>
      <div className={styles.project_videocontainer}>
        <div data-aos="fade-right">
          <img
            src="https://i.ibb.co/QvT8060/urbanC.png"
            alt="Urban Company"
          />
        </div>
      </div>
      <div className={styles.project_information}>
        <h2>Urban Company</h2>
        <p> Urban Company is Asia’s largest online home services platform. The platform helps customers book reliable & high-quality services — beauty treatments, massages, haircuts, home cleaning, handymen, appliance repair, painting, pest control, and more.</p>  <div className={styles.project_skills}> 
        <OneSkill skill="vscode-icons:file-type-html" sName="HTML"/><OneSkill/>
        <OneSkill skill="vscode-icons:file-type-css" sName="CSS"/><OneSkill/>
        <OneSkill className={styles.icon_rotate} skill="logos:react" sName="React.js"/><OneSkill/>
        <OneSkill skill="logos:javascript" sName="JavaScript"/><OneSkill/>
        <OneSkill skill="logos:redux" sName="Redux"/><OneSkill/>
        <OneSkill className={styles.icon_invert} skill="logos:express" sName="Express.js"/><OneSkill/>
        <OneSkill skill="logos:nodejs-icon" sName="Node.js"/><OneSkill/>
        <OneSkill skill="logos:mongodb" sName="MongoDB"/><OneSkill/>
        
        </div>
        <div>
          <a
            href="https://urban-company.netlify.app/homepage"
            target="_blank"
            rel="noreferrer"
          >
            <span type="button" className="btn-blue_active">
              See this Live
            </span>
          </a>
          <a
            href="https://github.com/ankitkumar3443/Urban_Company_Clone"
            target="_blank"
            rel="noreferrer"
          >
            <span type="button" className="btn-blue">
              View Code
            </span>
          </a>
        </div>
      </div>
    </div>
  </div>
}

export default UrbanC;
